import React, { Component } from "react";
import {
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Button, 
  Modal, 
  Col,
  Panel,
  OverlayTrigger,
  Table,
  Tooltip
 } from "react-bootstrap";
import './AlertDetail.css';
import { invokeApig } from "../../libs/awsLib";

export class AlertDetail extends Component {
  constructor(props) {
    super(props);

    this.typeOptions = [
      { id: 'UNIT', label: 'Vehículo(s)'},
      { id: 'TAG', label: 'Grupo de vehículos'},
      { id: 'ALL', label: 'Todos los vehículos'}
    ];

    this.semaphoreOptions = [
        { id: 'RED', label: 'Rojo (grave)'},
        { id: 'YELLOW', label: 'Amarillo (moderado)'},
        { id: 'GREEN', label: 'Verde (leve)'}
    ];

    this.state = {
      show: false,
      alert: null
    };
  }

  getAlert() {
    return invokeApig({
      path: `/alert/${this.props.alertId}`
    });
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  handleShow = async event =>{
    event.preventDefault();
    try {
      const results = await this.getAlert();
      if (results && !results.errorMessage) {
        let alert = results[0];
        alert.typeDescription = this.typeOptions.find(type => {return type.id === alert.type.toUpperCase();}).label;
        alert.semaphoreDescription = this.semaphoreOptions.find(semaphore => {return semaphore.id === alert.semaphore.toUpperCase();}).label; 
        this.setState({ alert: alert, show: true });
      } else {
        this.setState({ alert: undefined, show: false });
        alert('Alerta no encontrada');
      }
    } catch (e) {
      alert(e);
    }
  }

  renderAlert(){
    return(
      <Form horizontal> 
        <FormGroup>
        <Col componentClass={ControlLabel} sm={4}>Nombre</Col>
        <Col sm={8}><FormControl.Static>{this.state.alert.nameAlert}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
        <Col componentClass={ControlLabel} sm={4}>Descripción</Col>
        <Col sm={8}><FormControl.Static>{this.state.alert.description}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
        <Col componentClass={ControlLabel} sm={4}>Semáforo</Col>
        <Col sm={8}><FormControl.Static>{this.state.alert.semaphoreDescription}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
        <Col componentClass={ControlLabel} sm={4}>{this.state.alert.type === 'TAG' ? 'Grupo de Vehículos' : 'Vehículos'}</Col>
        <Col sm={8}>
          <FormControl.Static>
            {
              this.state.alert.type === 'ALL' ? this.state.alert.typeDescription :
              this.state.alert.type === 'UNIT' ? this.state.alert.units.map((unit, index) => (index > 0 ? ', ' : '') + unit.internalNumber) :
              this.state.alert.type === 'TAG' ? this.state.alert.tags.map((tag, index) => (index > 0 ? ', ' : '') + tag) : ''
            }
          </FormControl.Static>
        </Col>
        </FormGroup>
        <FormGroup>
        <Col componentClass={ControlLabel} sm={4}>Escalar A</Col>
        <Col sm={8}>
          {
            this.state.alert.escalations && this.state.alert.escalations.length > 1 ?
              <Table responsive>
                <thead>
                  <tr>
                    <th>Nivel</th>
                    <th>Tiempo</th>
                    <th>Emails</th>
                  </tr>
                </thead>
                <tbody>
                  {
                  this.state.alert.escalations.map(function(escalation, index){
                    return (
                      <tr key={index}>
                        <td>{escalation.level}</td>
                        <td>{escalation.time}</td>
                        <td>{escalation.emailType + ': ' + escalation.emails}</td>
                    </tr>
                    )
                  })
                  }
                </tbody>
              </Table>
              : 'Sin escalamientos'
            }
        </Col>
        </FormGroup>
        <FormGroup>
        <Col componentClass={ControlLabel} sm={4}>Fecha de creación</Col>
        <Col sm={8}><FormControl.Static>{this.state.alert.creationDate}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
        <Col componentClass={ControlLabel} sm={4}>Última actualización</Col>
        <Col sm={8}><FormControl.Static>{this.state.alert.lastUpdateDate}</FormControl.Static></Col>
        </FormGroup>
        <Panel defaultExpanded={false}>
            <Panel.Heading>
              Historial de cambios <Panel.Toggle componentClass="a" className="showHistory">Ver historial</Panel.Toggle>
            </Panel.Heading>
            <Panel.Collapse>
              <Panel.Body>
                {
                this.state.alert.changeHistory && this.state.alert.changeHistory.map(function(history, index){
                return (
                  <div key={index}>
                    <Col sm={5}><FormControl.Static><b>{history.dateFormat}</b></FormControl.Static></Col>
                    <Col sm={7}><FormControl.Static><b>{history.user}</b></FormControl.Static></Col>
                    <Col sm={12}><FormControl.Static>{history.change}</FormControl.Static></Col>
                </div>
                )
                })
                }
              </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </Form>
    );
  }

  render() {
    const tooltipDetail = (<Tooltip id="tooltipDetail"><strong>Ver Detalles</strong></Tooltip>);
    return (
      <div>
        <OverlayTrigger placement="right" overlay={tooltipDetail}>
	        <a onClick={this.handleShow} href="#alert">{this.props.nameAlert}</a>
        </OverlayTrigger>
          <Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Datos de la alerta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.alert && this.renderAlert() }
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose}>Cerrar</Button>
            </Modal.Footer>
          </Modal>
    </div>
    );
  }
}

export default AlertDetail


// WEBPACK FOOTER //
// ./src/containers/alert/AlertDetail.js